import Axios from 'axios'
import qs from 'qs'
import router from './../router'

// axios 配置
// Axios.defaults.timeout = 5000
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
Axios.defaults.baseURL = '//server.try233.com/api/agent/'
// Axios.defaults.baseURL = '//13.158.46.65/api/agent/'
// Axios.defaults.baseURL = '//127.0.0.1:8000/api/agent/'
Axios.defaults.withCredentials = false

// 取消请求
const CancelToken = Axios.CancelToken

// http request 拦截器
Axios.interceptors.request.use(config => {
  // 参数 requestName 字段，用于决定下次发起请求，取消对应的 相同字段的请求
  // 如果没有 requestName 就默认添加一个 不同的时间戳
  let requestName
  if (config.method === 'post') {
    if (config.data && config.data.requestName) {
      requestName = config.data.requestName
    } else {
      requestName = new Date().getTime()
    }
  }

  if (
    localStorage.token !== undefined &&
    localStorage.token !== null &&
    localStorage.token !== '') {
    config.data.tk = localStorage.token
  }

  // 判断，如果这里拿到的参数中的 requestName 在上一次请求中已经存在，就取消上一次的请求
  if (requestName) {
    if (Axios[requestName] && Axios[requestName].cancel) {
      Axios[requestName].cancel('取消请求')
    }
    config.cancelToken = new CancelToken(c => {
      Axios[requestName] = {}
      Axios[requestName].cancel = c
    })
  }

  // config.data.user_token = localStorage.user_token

  config.data = qs.stringify(config.data)
  config.headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  }

  return config
}, err => {
  // 错误

  return Promise.reject(err)
})
// http response 拦截器
Axios.interceptors.response.use(res => {
  // 成功

  if (res.data.status === 'M00005') {
    localStorage.token = ''
    localStorage.username = ''
    localStorage.role = ''
    localStorage.alist = []
    router.push('/login')
  }

  return res
}, err => {
  // err
  // this.$notify({
  //   title: '请求失败',
  //   message: '服务器繁忙,请稍后重试',
  //   type: 'warning'
  // })
  return Promise.reject(err)
})

/**
 * fetch 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function fetch (url, params = {}) {
  return new Promise((resolve, reject) => {
    Axios.get(url, {
      params: params
    }).then(response => {
      resolve(response.data)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.post(url, data).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}

export default Axios
